export { Icon, SIZES, VARIANTS } from "./Icon";
export {
  assertIsKazooIcon,
  checkKazooIconWithFallback,
  isKazooIcon,
} from "./assertIsKazooIcon";
export { IconDictionary } from "./types";
